import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '../../../environments/environment';

export function authConfigFactory(): AuthConfig {
  return {
    issuer: environment.ISSUER_URL,
    redirectUri: environment.REDIRECT_URI,
    clientId: environment.CLIENT_ID,
    responseType: 'code',
    scope: 'openid profile email',
    showDebugInformation: environment.showDebugInformation,
    strictDiscoveryDocumentValidation: false,
    requireHttps: true,
    useHttpBasicAuth: false,
    disablePKCE: false,
    postLogoutRedirectUri: environment.POST_LOGOUT_REDIRECT_URL,
  };
}
